import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Divider, Typography } from '@mui/material';
import Grid from 'material/components/Grid';

import { patchUser, updatePassword } from 'store/actions/auth';
import { authSelectors } from 'store/selectors/auth';

import { Container } from 'common/components';
import BreadcrumbsNavigation from 'common/components/BreadcrumbsNavigation';
import TopCard from 'common/containers/TopCard';

import { CardWrapper } from 'globalStyles';

import ContactInfoForm from 'routes/AccountDetails/components/ContactInfoForm';
import UpdatePasswordForm from 'routes/AccountDetails/components/UpdatePasswordForm';

const ContactInfoFormWrapper = styled.div`
  width: 50%;
  padding-top: 10px;

  &:first-of-type {
    padding-right: 40px;
  }
`;

const StyledDivider = styled(Divider)`
  margin-bottom: 20px;
`;

const CONTACT_INFO_TITLE = 'Contact Info';
const UPDATE_PASSWORD_TITLE = 'Update Password';

const breadcrumbs = [
  {
    link: '',
    name: 'Account Settings',
  },
];

const AccountDetails = ({ location }) => {
  const dispatch = useDispatch();
  const {
    user: { email, firstName, lastName },
  } = useSelector(state => ({
    user: authSelectors.getUser(state),
  }));

  const onPasswordSubmit = async ({ newPassword, oldPassword }) => {
    const params = {
      newPassword,
      oldPassword,
    };

    try {
      await dispatch(updatePassword(params));

      return 'success';
    } catch (error) {
      return error;
    }
  };

  const onSubmit = async values => {
    try {
      await dispatch(patchUser(values));

      return 'success';
    } catch (error) {
      return error;
    }
  };

  const initialValues = {
    email,
    firstName,
    lastName,
  };

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container>
        <Grid container>
          <TopCard
            title="Account Settings"
            backButtonLink={location?.state?.goBackLink || '/organizations'}
          />
        </Grid>
        <CardWrapper>
          <Grid container>
            <ContactInfoFormWrapper>
              <Typography variant="h6">{CONTACT_INFO_TITLE}</Typography>
              <StyledDivider />
              <ContactInfoForm initialValues={initialValues} onSubmit={onSubmit} />
            </ContactInfoFormWrapper>
            <ContactInfoFormWrapper>
              <Typography variant="h6">{UPDATE_PASSWORD_TITLE}</Typography>
              <StyledDivider />
              <UpdatePasswordForm onSubmit={onPasswordSubmit} />
            </ContactInfoFormWrapper>
          </Grid>
        </CardWrapper>
      </Container>
    </>
  );
};

AccountDetails.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      goBackLink: PropTypes.string,
    }),
  }).isRequired,
};

export default AccountDetails;
